import type { RootState } from 'js/src/libs/RootState';

const ownValue = <T>(record: Readonly<Record<string, T>>, key: string): T | undefined =>
    Object.prototype.hasOwnProperty.call(record, key) ? record[key] : undefined;

export const getAudioEnhancementStatusForSceneGroup = (state: RootState, sceneGroupId: string) => {
    return ownValue(state.audio_enhancement.audio_enhancement_status, sceneGroupId);
};

export const getIsAudioEnhancementLoadingForSceneGroup = (
    state: RootState,
    sceneGroupId: string,
): boolean | undefined => {
    return ownValue(state.audio_enhancement.AUDIO_ENHANCEMENT_LOADING, sceneGroupId)?.isLoading;
};

export const getAudioEnhancementLoadingAbortController = (
    state: RootState,
    sceneGroupId: string,
): AbortController | undefined => {
    return ownValue(state.audio_enhancement.AUDIO_ENHANCEMENT_LOADING, sceneGroupId)
        ?.abortController;
};
